import $ from "jquery";
import { application } from "../application/application";
import { siteDashboardFilters } from "./siteDashboardFilter";
import { siteSearch } from "./siteSearch";
import { services } from "../services/notificationService";
import { forms } from "../framework/forms";

let sitesTable;
let dataSet = [];
let currentPage = 1;
let pageSize = 20;
let totalMatchedRecords = 0;
let hasNextPage;
const tableColumns = ["SiteName", "City", "State", "Country", "Region", "", "Area", "SiteId", "IsActive"];

function init() {
    forms.showSpinner();
    buildTable();

    setNextPrevButtonEnabled();

    siteDashboardFilters.doSetup().done(function() {
        currentPage = 1;
        populateTable();
        setEvents();
        forms.hideSpinner();
    }).fail(function() {
        services.notificationService.error("An unexpected error has occurred. Please try again later.");
        forms.hideSpinner();
    });
}

function setEvents() {
    $("#btnDownloadExcelCurrPage").click(function () {
        $(this).attr("href", exportSitesToExcel(false));
    });
    $("#btnDownloadExcelAll").click(function () {
        $(this).attr("href", exportSitesToExcel(true));
    });

    function exportSitesToExcel(getAll) {
        let source = "";
        if (getAll)
            source = "/Sites/GetSiteSearchExcel" + "/-1/?";
        else
            source = "/Sites/GetSiteSearchExcel" + "/" + currentPage + "/?";
        const sourceWithParams = source += $.param(siteDashboardFilters.getQueryStringFilters()).replace(/%5B%5D/g, "");
        return sourceWithParams;
    }
    $("#next").click(goNextPage);

    $("#previous").click(goPreviousPage);

    $("#applyFilters").click(applyFilters);

    $("#clearFilters").click(clearFilters);

    $(document).on("dblclick", "#sitesTable tbody tr", goToSite);

    $(".sorting, .sorting_asc, .sorting_desc").click(function(e) {
        const asc = $(this).hasClass("sorting") || $(this).hasClass("sorting_desc");
        $(".sorting, .sorting_asc, .sorting_desc").removeClass()
            .addClass("sorting");

        if (asc) {
            $(this).removeClass("sorting").removeClass("sorting_desc").addClass("sorting_asc");
        } else {
            $(this).removeClass("sorting").removeClass("sorting_asc").addClass("sorting_desc");
        }
        $(".sorting, .sorting_asc, .sorting_desc").not($(this)).removeClass(".sorting_asc").removeClass(".sorting_desc")
            .addClass("sorting");

        const sort = {
            column: tableColumns[sitesTable.column(this).index()],
            columnIndex: sitesTable.column(this).index(),
            desc: $(this).hasClass("sorting_desc")
        };
        siteDashboardFilters.setSort(sort.column, sort.columnIndex, sort.desc);
        currentPage = 1;
        populateTable();
    });

    $("#site-search").submit(function(e) {
        e.preventDefault();
        applyFilters();
    });
}

function buildDataSet(sites) {
    dataSet = [];
    for (let i = 0; i < pageSize && i < sites.length; i++) {
        dataSet.push([sites[i].siteName, sites[i].city, sites[i].state, sites[i].country, sites[i].region, sites[i].regionDescription, sites[i].area, sites[i].siteId, sites[i].isActive]);
    }
    hasNextPage = (currentPage * pageSize) < totalMatchedRecords;//sites.length > pageSize;
}
function buildTable() {
    if (sitesTable !== undefined) {
        sitesTable.destroy();
    }
    sitesTable = $("#sitesTable").DataTable({
        "serverSide": false, // for process server side
        "filter": false, // this is for disable filter (search box)
        //"orderMulti": false, // for disable multiple column at once
        "data": dataSet,
        "bLengthChange": false,
        "bPaginate": false,
        "PageLength": 20,
        "bInfo": false,
        "ordering": false,
        "columnDefs":
            [
                {
                    "targets": 0,
                    "name": "Site Name"
                },
                {
                    "targets": 1,
                    "name": "City"
                },
                {
                    "targets": 2,
                    "name": "State"
                },
                {
                    "targets": 3,
                    "name": "Country"
                },
                {
                    "targets": 4,
                    "name": "Region",
                    mRender: function(data, type, row) {
                        if (data === undefined) return "";
                        return "<div>" + data + "</div>";
                    }
                },
                {
                    "targets": 5,
                    "name": "Description",
                    "visible": false
                },
                {
                    "targets": 6,
                    "name": "Approval Area"
                },
                {
                    "targets": 7,
                    "name": "Site ID"
                },
                {
                    "targets": 8,
                    "name": "Status",
                    mRender: function(data, type, row) {
                        if (data === undefined) return "";
                        return "<i class='fa fa-circle' style='color: " +
                            (!data ? "Red" : "Green") +
                            "'></i> " +
                            (data ? "Active" : "Inactive");
                    }
                }
            ]
    });
    $("#sitesTable [data-toggle=\"tooltip\"]").tooltip();
    siteDashboardFilters.setSitesTable(sitesTable);
}
function setNextPrevButtonEnabled() {
    if (!hasNextPage) {
        $("#next").addClass("disabled");
    } else {
        $("#next").removeClass("disabled");
    }
    if (currentPage === 1) {
        $("#previous").addClass("disabled");
    } else {
        $("#previous").removeClass("disabled");
    }
}
function goNextPage() {
    if (!hasNextPage) return;
    currentPage++;
    populateTable();
}
function goPreviousPage() {
    if (currentPage === 0) return;
    currentPage--;
    populateTable();
}
function applyFilters() {
    currentPage = 1;
    siteDashboardFilters.setFilters();
    populateTable();
}
function clearFilters() {
    currentPage = 1;
    siteDashboardFilters.clearFilters();
    populateTable();
}

function populateTable() {
    const filters = siteDashboardFilters.getFilters();
    return $.Deferred(function(def) {
        siteSearch.getSites(currentPage, filters).done(function(results) {
            $("#PagingInfo").text("Page " + currentPage + " of " + results.pageCount + ". Matched records = " + results.totalMatchedRecords);
            totalMatchedRecords = results.totalMatchedRecords;
            pageSize = results.pageSize;
            buildDataSet(results.results);
            setNextPrevButtonEnabled();
            sitesTable.clear();
            sitesTable.rows.add(dataSet).columns.adjust().draw();
            $("#sitesTable [data-toggle=\"tooltip\"]").tooltip();
            def.resolve();
        });
    }).promise();
}
function goToSite() {
    const data = sitesTable.row(this).data();
    if (data === undefined) {
        return;
    }
    forms.showSpinner();
    window.location.href = application.baseUrl + "/sitedetails/index/" + data[7];
}

export const siteDashboard = {
    init: init
};